export default __webpack_public_path__ + "static/media/face-new.09456ebf.png";